import React, { useState } from 'react';
import { Columns } from '@components/Columns';
import {
  StyledRegistryCross,
  StyledMobileLoader,
  StyledDesktopLoader,
  StyledCenterBody,
  ButtonsContainer,
  FeatureText,
  CrossTextPairing,
  StyledTextColumn,
  FeatureImage,
  StyledAppCTALink,
  JoyOverviewColumns,
  JoyOverviewColumnsMobile,
  JoyOverviewColumn,
} from './RegistryCross.styles';
import ReactHtmlParser from 'react-html-parser';
import { Flex } from '@components/Flex';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

interface RegistryCrossProps {}

export const RegistryCross: React.FC<RegistryCrossProps> = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleMobile, setIsVisibleMobile] = useState(false);
  const { t } = useTranslation('cashFundRegistry');
  const registryCrossSectionData = t('registryCrossSection');
  const getStarted = t('getStarted');
  const learnMore = t('learnMore');

  return (
    <StyledRegistryCross as="section" id="Registry_Best_Part">
      <StyledDesktopLoader>
        <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
          <div />
        </LazyLoadWrapper>
      </StyledDesktopLoader>
      <StyledMobileLoader>
        <LazyLoadWrapper beforeLoad={() => setIsVisibleMobile(true)}>
          <div />
        </LazyLoadWrapper>
      </StyledMobileLoader>
      <StyledCenterBody paddingTop={[11, 12]} paddingBottom={[0]}>
        <JoyOverviewColumnsMobile marginBottom={10} centered>
          <JoyOverviewColumn width={12}>
            <PlaceholderCloudImage src={registryCrossSectionData.image} width={'100%'} isMainSrcShown={isVisibleMobile} />
          </JoyOverviewColumn>
        </JoyOverviewColumnsMobile>
        <StyledTextColumn centered>
          <Columns.Column width={12}>
            <Flex flexDirection={'column'} alignItems={'center'} paddingBottom={[5]}>
              <CrossTextPairing
                alignment="center"
                eyebrow={registryCrossSectionData.eyebrow}
                eyebrowColor="humanaDark4"
                eyebrowVariant="sectionEyeBrow20"
                eyebrowTagName="h2"
                title={registryCrossSectionData.title}
                titleVariant="hed56"
                titleColor="humanaDark6"
                titleTagName="h2"
                body={registryCrossSectionData.body}
                bodyVariant="dek20"
                bodyColor="neutra6"
                bodyTagName="p"
              />
              <Flex flexDirection={'row'} alignItems={'center'} justifyItems={'center'} paddingBottom={[0]}>
                <ButtonsContainer marginTop={[10]}>
                  <GetStartedButton id="cashRegistryBestPartGetStartedBtn" page={'registry'} variant="secondary">
                    {getStarted}
                  </GetStartedButton>
                </ButtonsContainer>
                <StyledAppCTALink id={'cashRegistryLearnMore'} aria-label="Wedding Website" href="/wedding-website" hasChevron>
                  {learnMore}
                </StyledAppCTALink>
              </Flex>
            </Flex>
          </Columns.Column>
        </StyledTextColumn>
        <Columns marginTop={8} marginBottom={10} centered verticalAlign="flex-start">
          {registryCrossSectionData.featuresData.map((item, index) => (
            <Columns.Column key={index} width={3}>
              <Flex alignItems="center" justifyContent="center" flexDirection="column">
                <FeatureImage>
                  <PlaceholderCloudImage src={item.image} width={32} height={32} isMainSrcShown={true} optimization="aggressive" />
                </FeatureImage>
                <FeatureText textAlign="center" tagName="h2" variant="featureHed17" color="humanaDark6">
                  {ReactHtmlParser(item.title)}
                </FeatureText>
              </Flex>
            </Columns.Column>
          ))}
        </Columns>
        <JoyOverviewColumns marginBottom={10} centered>
          <JoyOverviewColumn width={12}>
            <PlaceholderCloudImage src={registryCrossSectionData.image} width={'100%'} isMainSrcShown={isVisible} />
          </JoyOverviewColumn>
        </JoyOverviewColumns>
      </StyledCenterBody>
    </StyledRegistryCross>
  );
};
